import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';

// Material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ImgFallbackModule } from '@app/shared/directives/img-fallback/img-fallback.module';
import { StarRatingModule } from '@app/shared/components/star-rating/star-rating.module';
import { PercentageDifferenceComponent } from './percentage-difference/percentage-difference.component';
import { ScoreChangeModule } from '@app/shared/components/score-change/score-change.module';

@NgModule({
  declarations: [HomeComponent, PercentageDifferenceComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ImgFallbackModule,
    StarRatingModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    ScoreChangeModule,
  ],
})
export class HomeModule {}
